import { ApiService } from './ApiService';

export const ApiProject = {
  projectList: (userId: string, search?: string, take?: number, page?: number, startDate?: string, endDate?: string) => `${ApiService.project}?userId=${userId}&search=${search}&take=${take}&page=${page}&startDate=${startDate}&endDate=${endDate}`,
  projectDetail: (userId: string, projectId: string, take?: number, page?: number) => `${ApiService.project}/detail?userId=${userId}&projectId=${projectId}&take=${take}&page=${page}`,
  collaborationProjectReqList: (userId: string, search: string, take: number, page: number, startDate: string, endDate: string) => `${ApiService.project}/request?userId=${userId}&search=${search}&take=${take}&page=${page}&startDate=${startDate}&endDate=${endDate}`,
  createProject: `${ApiService.project}`,
  deleteProject: `${ApiService.project}/delete`,
  updateProject: `${ApiService.project}/update`,
  reqToCollaborate: `${ApiService.project}/request`,
  approveCollaborationReq: `${ApiService.project}/request/approve`,
  rejectCollaborationReq: `${ApiService.project}/request/reject`,
  downloadCSV: (projectId: string) => `${ApiService.project}/download?projectId=${projectId}`,
};
